// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","410":"component---src-pages-blog-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"351":"e826334581a4022c67e2","410":"7941383e542a4a5d4098","691":"c6b2d2b737abf2aaaa2f"}[chunkId] + ".js";
};